import React, { useEffect, useState } from 'react';
import { Alert, Box, Tab, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { DEEP_GREEN, MUTED } from '../colorTokens';
import ZoomSafeTabs from '../../common/ZoomSafeTabs';
import { hasOperationalExcellenceAccess } from '../../../services/authService';
import MonthlyReport from '../incident-remediation/MonthlyReport';
import ReleaseCadenceTab from '../release-cadence/ReleaseCadenceTab';

const GREEN_LIGHT = '#2C4A3A';

const TABS = [
  { id: 'incident-remediation', label: 'Incident Remediation' },
  { id: 'release-cadence', label: 'Release Cadence' }
];

const ConfidencePlanPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = searchParams.get('tab');
  const initialTab = TABS.some((tab) => tab.id === tabFromUrl) ? tabFromUrl : TABS[0].id;
  const [activeTab, setActiveTab] = useState(initialTab);

  useEffect(() => {
    if (TABS.some((tab) => tab.id === tabFromUrl) && tabFromUrl !== activeTab) {
      setActiveTab(tabFromUrl);
    }
  }, [tabFromUrl, activeTab]);

  if (!hasOperationalExcellenceAccess()) {
    return (
      <Box sx={{ p: 4 }}>
        <Alert severity="error" sx={{ maxWidth: 520 }}>
          You do not have access to Operational Excellence. Ask an administrator to grant it in Admin → User Management.
        </Alert>
      </Box>
    );
  }

  const handleTabChange = (_event, value) => {
    setActiveTab(value);
    const next = new URLSearchParams(searchParams);
    // Keep LandingPage section= when this page is embedded on /
    if (!next.get('section') && window.location.pathname === '/') {
      next.set('section', 'confidence-plan');
    }
    next.set('tab', value);
    setSearchParams(next, { replace: true });
  };

  return (
    <Box sx={{ width: '100%', maxWidth: '100%' }}>
      <Box
        sx={{
          borderRadius: '12px',
          background: `linear-gradient(120deg, ${DEEP_GREEN}, ${GREEN_LIGHT})`,
          color: '#fff',
          px: { xs: 2, md: 2.5 },
          py: { xs: 1.5, md: 2 }
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 700, letterSpacing: '-0.02em', lineHeight: 1.2 }}>
          Confidence Plan
        </Typography>
        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.75)', mt: 0.35, fontWeight: 500 }}>
          Operational Excellence
        </Typography>
      </Box>

      <ZoomSafeTabs
        value={activeTab}
        onChange={handleTabChange}
        sx={{
          minHeight: 0,
          borderBottom: '1px solid rgba(26,46,34,0.12)',
          mt: 2,
          mb: 2.5
        }}
        indicatorColor={DEEP_GREEN}
      >
        {TABS.map((tab) => (
          <Tab
            key={tab.id}
            value={tab.id}
            label={tab.label}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '0.9rem',
              color: MUTED,
              '&.Mui-selected': { color: DEEP_GREEN }
            }}
          />
        ))}
      </ZoomSafeTabs>

      {activeTab === 'incident-remediation' && <MonthlyReport />}
      {activeTab === 'release-cadence' && <ReleaseCadenceTab />}
    </Box>
  );
};

export default ConfidencePlanPage;
